// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3kBng","emails":"CreateEditClinics_emails__11Yj-","emailTagLabel":"CreateEditClinics_emailTagLabel__3OLq6"};